import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import './Auth.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [mode, setMode] = useState('signin');
  const [resetSent, setResetSent] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const { error } = await supabase.auth.signInWithPassword({ email, password });

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      navigate('/dashboard');
    }
  };

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setResetSent(false);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });

    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }

    setResetSent(true);
    setLoading(false);
  };

  const handleGoogleLogin = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: { redirectTo: `${window.location.origin}/dashboard` },
    });
    if (error) setError(error.message);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <img src="/tru_stride_logo.svg" alt="Tru-Stride" className="auth-logo" />
          <h2>{mode === 'forgot' ? 'Reset password' : 'Welcome Back'}</h2>
          <p>{mode === 'forgot' ? 'We’ll email you a reset link.' : 'Sign in to your Tru-Stride account'}</p>
        </div>

        {error && <div className="auth-error">{error}</div>}
        {resetSent && (
          <div className="auth-success">
            If an account exists for {email}, we sent a reset link. Check that inbox.
          </div>
        )}

        {mode === 'forgot' ? (
          <form onSubmit={handleForgotPassword} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
                autoComplete="email"
              />
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>
            <button
              type="button"
              className="auth-text-button"
              onClick={() => {
                setMode('signin');
                setError(null);
              }}
            >
              Back to sign in
            </button>
          </form>
        ) : (
        <form onSubmit={handleLogin} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={8}
            />
            <button
              type="button"
              className="auth-forgot"
              onClick={() => {
                setMode('forgot');
                setError(null);
                setResetSent(false);
              }}
            >
              Forgot password?
            </button>
          </div>

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        )}

        {mode === 'signin' && (
          <>
            <div className="auth-divider"><span>or</span></div>

            <button onClick={handleGoogleLogin} className="google-button">
              <span>🔵</span> Sign in with Google
            </button>

            <p className="auth-footer">
              Don't have an account? <Link to="/signup">Create one</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
